import store from "redux/store";
import { baseApi } from "redux/baseAPI";
import { toast } from "react-toastify";
import { providerNoteSlice } from "../modules/ProviderNote/_redux/providerNoteSlice";
const { actions } = providerNoteSlice;

const baseApiHelper = () => {
    const id = window.location.href.split('/provider-note/')[1] || window.location.search.split('&id=')[1];

    const noteAutoAcceptHook = (url, result, data, hitSocket) => {
        let storeState = store.getState();
        let isFav = (data?.add_to_favorite && (data?.add_to_favorite==true || data?.add_to_favorite=='true' || data?.add_to_favorite==1 || data?.add_to_favorite=='1'));
        let isAcceptJsonRequest = url.indexOf('notes/accept.json') > -1;
        if (isAcceptJsonRequest) {
            result.data.response.meta = {auto_accept_response: result?.data?.response?.data};
        }
        processAutoAcceptNote(result?.data?.response, isFav, isAcceptJsonRequest);
        if (hitSocket && storeState && storeState?.auth && storeState?.auth?.socket && storeState?.auth?.socket?.connected) {
            let emitData = {
                "encounter_id": id,
                "key": 'e10x_auto_accept',
                "data": {
                    response: result?.data?.response,
                    add_to_favorite: isFav,
                    is_accept_json: isAcceptJsonRequest
                }
            };
            //console.warn(":::::: BROADCAST_NOTE ::::::", emitData);
            storeState.auth.socket.emit('broadcast_note', emitData);
        }
    }
    const checkAutoAcceptNoteExists = (response) => {
        /*
        * Check if response data contains `auto_accept_response` which indicates,
        * note data is already processed.
        */
        return (
            (response?.code == 0 || response?.data?.code == 0) &&
            (response?.meta || response?.data?.meta) &&
            (response?.meta?.auto_accept_response || response?.data?.meta?.auto_accept_response)
        );
    }
    const processAutoAcceptNote = (response, addToFavorite, isAcceptJsonRequest) => {
        if (checkAutoAcceptNoteExists(response)) {
            let mutationResponseData = response?.data || response?.data?.data;
            let autoAcceptResponse = response?.meta?.auto_accept_response || response?.data?.meta?.auto_accept_response;
            console.warn("<< Auto Accept Response >>", autoAcceptResponse);
            store.dispatch(baseApi.util.updateQueryData("getProviderNote", id, (draftNote) => {
                if (autoAcceptResponse?.gpt_clinical_data) {
                    draftNote.gpt_clinical_data = autoAcceptResponse?.gpt_clinical_data;
                }
                if (autoAcceptResponse?.ap_clinical_data) {
                    draftNote.ap_clinical_data = autoAcceptResponse?.ap_clinical_data;
                }
                if (autoAcceptResponse?.suggestions_counts) {
                    draftNote.suggestions_counts = autoAcceptResponse?.suggestions_counts;
                }
                if (autoAcceptResponse?.clinical_guidelines_count) {
                    draftNote.clinical_guidelines_count = autoAcceptResponse?.clinical_guidelines_count;
                }
                if (autoAcceptResponse?.component) {
                    if (!draftNote?.clinical_data) {
                        draftNote.clinical_data = {};
                    }
                    if (autoAcceptResponse?.component!='health_conditions' && 
                        autoAcceptResponse?.health_conditions) {
                        draftNote.clinical_data['health_conditions'] = autoAcceptResponse?.health_conditions;
                    }
                    switch (autoAcceptResponse?.component) {
                        case 'medications':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['medications'] = autoAcceptResponse.data;
                            }
                            invalidateTags(["DocumateMedicationsList", "ProviderNoteAPMedications", "Medication"]);
                            break;
                        case 'vital_signs':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['vital_signs'] = autoAcceptResponse.data;
                            }
                            invalidateTags(["DocumateVitalsList"]);
                            break;
                        case 'health_conditions':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse[autoAcceptResponse?.component];
                            if (isAcceptJsonRequest) {
                                draftNote['problem_facts'] = autoAcceptResponse.data;
                            }
                            invalidateTags(["DocumateAssessmentsList"]);
                            break;
                        case 'referrals':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['referrals'] = autoAcceptResponse.data;
                            }
                            invalidateTags(["DocumateReferralsList", "Referrals", "ProviderNoteAPReferrals"]);
                            break;
                        case 'allergies':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['allergies'] = autoAcceptResponse.data;
                            }
                            invalidateTags(["DocumateAllergiesList"]);
                            break;
                        case 'labs':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['labs'] = autoAcceptResponse.data;
                            }
                            invalidateTags(["DocumateLabsList", "ProviderNoteAPLabs", "DocumateLabResultsList", "Result", "labOrder", "LabOrdersInNote", "LabPendingOrders", "LabAwaitingResults", "LabFutureOrders"]);
                            break;
                        case 'lab_results':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['lab_results'] = autoAcceptResponse.data;
                            }
                            invalidateTags(["DocumateLabsList", "ProviderNoteAPLabs", "DocumateLabResultsList", "Result", "labOrder", "LabOrdersInNote", "LabPendingOrders", "LabAwaitingResults", "LabFutureOrders"]);
                            break;
                        case 'appointments':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['appointments'] = autoAcceptResponse.data;
                            }
                            break;
                        case 'educations':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['educations'] = autoAcceptResponse.data;
                            }
                            invalidateTags(["ProviderNoteAPEducation"]);
                            break;
                        case 'procedures':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['procedures'] = autoAcceptResponse.data;
                            }
                            invalidateTags(["DocumateProceduresList", "ProviderNoteAPProcedure", "Procedure"]);
                            break;
                        case 'treatment_plan':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['treatment_plan'] = autoAcceptResponse.data;
                            }
                            break;
                        case 'histories':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            // if (isAcceptJsonRequest) {
                            //     draftNote['histories'] = autoAcceptResponse.data;
                            // }
                            invalidateTags(["DocumateHistoriesList"]);
                            break;
                        case 'pt_screening':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['pt_screening'] = autoAcceptResponse.data;
                            }
                            break;
                        case 'asthma_action_plan':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['asthma_action_plan'] = autoAcceptResponse.data;
                            }
                            break;
                        case 'history_of_present_illness':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['history_of_present_illness'] = autoAcceptResponse.data;
                            }
                            break;
                        case 'immunization':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['immunization'] = autoAcceptResponse.data;
                            }
                            break;
                        case 'health_promotion_plans':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['health_promotion_plans'] = autoAcceptResponse.data;
                            }
                            break;
                        case 'radiology':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['radiology'] = autoAcceptResponse.data;
                            }
                            invalidateTags(["DocumateRadiologyList", "Radiology", "PendingRadiology"]);
                            break;
                        case 'goals':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['goals'] = autoAcceptResponse.data;
                            }
                            break;
                        case 'barriers':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['barriers'] = autoAcceptResponse.data;
                            }
                            break;
                        case 'wellwomen':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['wellwomen'] = autoAcceptResponse.data;
                            }
                            break;
                        case 'eye_exams':
                            draftNote.clinical_data[autoAcceptResponse?.component] = autoAcceptResponse?.ids;
                            if (isAcceptJsonRequest) {
                                draftNote['eye_exams'] = autoAcceptResponse.data;
                            }
                            break;

                        /* 
                        case 'epsdt':
                            draftNote.notes = draftNote?.notes?.map( note => {
                                if(note?.slug == 'epsdt'){
                                    return {
                                        ...note, combined_note_text: autoAcceptResponse.data
                                    }
                                }
                                return note;
                            });
                            break; */
                    }
                }
            }));
            if (addToFavorite && mutationResponseData) {
                if (autoAcceptResponse?.component) {
                    if (autoAcceptResponse?.component == "medications") {
                        invalidateTags(["ProviderNoteAPMedications","Medication"]);
                    }
                    else if (autoAcceptResponse?.component =="procedures"){
                        invalidateTags(["ProviderNoteAPProcedure","Procedure"]);

                    }
                    else if (autoAcceptResponse?.component =="radiology"){
                        invalidateTags(["ProviderNoteAPRadiology", "Radiology"]);

                    }
                }

                // let tempFav = cloneDeep(mutationResponseData);
                // tempFav.favorite_title = (mutationResponseData?.favorite_title || mutationResponseData?.title);
                // if (autoAcceptResponse?.component) {
                //     if (autoAcceptResponse?.component == "medications") {
                //         store.dispatch(baseApi.util.updateQueryData("getProviderNoteAPMedications","Medication", undefined, (draftFavMedications) => {
                //             draftFavMedications?.medication.push(tempFav);
                //         }));
                //     }
                // }
            }
        }
    }
    const updateNoteSliceField = (fieldName, fieldData, multipleFields) => {
        if (fieldName && fieldData && !multipleFields) {
            store.dispatch(baseApi.util.updateQueryData("getProviderNote", id, (draftNote) => {
                draftNote[fieldName] = fieldData;
            }));
        } else if (multipleFields && !fieldName && !fieldData) {
            store.dispatch(baseApi.util.updateQueryData("getProviderNote", id, (draftNote) => {
                for(let key in multipleFields) {
                    draftNote[key] = multipleFields[key];
                }
            }));
        }
    }
    const invalidateTags = (tagsToInvalidate) => {
        if (tagsToInvalidate && tagsToInvalidate.length > 0) {
            store.dispatch(baseApi.util.invalidateTags(tagsToInvalidate));
        }
    }
    const invalidateThroughSocket = (receivedComponent, extraData, updateLocalData) => {
        store.dispatch((dispatch, getState) => {
            switch (receivedComponent) {
                case 'medications':
                  invalidateTags(["ProviderNoteAPMedications","Medication"]);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumateMedicationsList']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'vital_signs':
                  invalidateTags(["Vitals", "CurrentVitals"]);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumateVitalsList']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'health_conditions':
                  invalidateTags(["Problems"]);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumateAssessmentsList']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'referrals':
                  invalidateTags(["Referrals"]);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumateReferralsList', 'Referrals', 'ProviderNoteAPReferrals']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'allergies':
                  invalidateTags(["Allergies"]);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumateAllergiesList']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'labs':
                  invalidateTags(['Result', 'labOrder', 'LabOrdersInNote', 'LabPendingOrders', 'LabAwaitingResults', 'LabFutureOrders']);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumateLabsList', 'ProviderNoteAPLabs']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'lab_results':
                  invalidateTags(['Result', 'labOrder', 'LabOrdersInNote', 'LabPendingOrders', 'LabAwaitingResults', 'LabFutureOrders']);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumateLabsList', 'ProviderNoteAPLabs']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'appointments':
                  invalidateTags(['Appointments']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                  break;
                  case 'educations':
                    invalidateTags(['ProviderNoteAPEducation']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'procedures':
                  invalidateTags(["ProviderNoteAPProcedure","Procedure"]);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumateProceduresList']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'radiology':
                  invalidateTags(["Radiology", "ProviderNoteAPRadiology"]);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumateRadiologyList', 'Radiology', 'PendingRadiology']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'histories':
                  invalidateTags(['history', 'Legacy', 'fetchHistory', 'fetchLegacyHistory', 'fetchObgynHistory', 'historyStatus']);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumateHistoriesList']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'pt_screening':
                  invalidateTags(['PediatricDevelopment', 'ScreeningForm', 'PatientScreening']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'asthma_action_plan':
                  invalidateTags(['AsthmaPlan']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'epsdt':
                  invalidateTags(['getEPSDT', 'PediatricDevelopment', 'ScreeningForm', 'PatientScreening']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'physical_examination':
                  invalidateTags(['PhysicalExam', 'PeSoapText']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'review_of_systems':
                  if (extraData) {
                    invalidateTags(extraData.tags || []);
                  }
                break;
                case 'refusal':
                  invalidateTags(['Refusal']);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                break;
                case 'family_planning':
                  invalidateTags(["getProviderNote", "ProviderNote"]);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                case 'reconciliations':
                  invalidateTags(["Reconciliations"]);
                  if (extraData) {
                    /// do something with your extraData, if sent
                  }
                case 'epsdt_hipaa_referrals':
                  if (extraData?.hipaa_referral_code) {
                    updateNoteSliceField('hipaa_referral_code', extraData?.hipaa_referral_code);
                  }
                break;
                case 'update_provider_note':
                  invalidateTags(["ProviderNote", "ProviderNotePreview"]);
                  updateNoteSliceField('notes_updated', Date?.now());
                break;
                case 'past_medical_histories':
                  invalidateTags(["Problems"]);
                break;
                case 'past_medical_history':
                  invalidateTags(["Problems"]);
                  localDocumateRTKStateOverwrite(updateLocalData, ['DocumatePastMedicalHistoryList']);
                break;
                case 'historyData':
                  invalidateTags(["historyData"]);
                break;
            }
        });
    }
    const localDocumateRTKStateOverwrite = (dataToOverwrite, rtkQueryMethods) => {
      invalidateTags(rtkQueryMethods);
      // rtkQueryMethods.forEach(reduxStateName => {
      //   console.warn("..........", reduxStateName, dataToOverwrite);
      //   try {
      //     store.dispatch(baseApi.util.updateQueryData(reduxStateName, 'response',(draftItem) => {
      //       draftItem.response.data = dataToOverwrite;
      //     }));
      //   } catch (err) {
      //     console.warn("nnnnnnn", err);
      //   }
      // });
    }
    const responseMSGCheck = (response) => {
      if ((response?.code == -1 || response?.code == '-1') && response?.msg && response?.msg?.length > 0) {
        toast.error(response?.msg);
        console.error("------------------------------ERROR------------------------------", response);
      } else if ((response?.code == -21 || response?.code == '-21') && response?.msg && response?.msg?.length > 0) {
        // General Alert Dialog
        const alertDialogObj = {
            open: true,
            title: "Caution!",
            msg: response?.msg,
            type: "info",
        };
        store.dispatch(
          actions.initConfirmationDialog({ data: { ...alertDialogObj } })
        );
      } else if (typeof response?.code == 'undefined') {
        toast.error("Something went wrong, please try again later.");
      }
    }

    return {
        noteAutoAcceptHook: noteAutoAcceptHook,
        checkAutoAcceptNoteExists: checkAutoAcceptNoteExists,
        processAutoAcceptNote: processAutoAcceptNote,
        updateNoteSliceField: updateNoteSliceField,
        invalidateTags: invalidateTags,
        invalidateThroughSocket: invalidateThroughSocket,
        localDocumateRTKStateOverwrite: localDocumateRTKStateOverwrite,
        responseMSGCheck: responseMSGCheck,
    };
}

export default baseApiHelper;